import type {MouseEvent} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, cn} from '@chekinapp/ui';
import {usePrivacyPolicyLink} from './usePrivacyPolicyLink';

const LINK_CLASS = 'privacy-policy-link ml-1 text-sm font-semibold leading-5';

const NEW_TAB = {target: '_blank', rel: 'noopener noreferrer'} as const;

type PrivacyPolicyLinkProps = {
  className?: string;
  onOpenDocument?: (url: string) => void;
};

function PrivacyPolicyLink({className, onOpenDocument}: PrivacyPolicyLinkProps) {
  const {t} = useTranslation();
  const {href, isCustomDocument, isPdf} = usePrivacyPolicyLink();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!onOpenDocument || !isPdf) return;

    event.preventDefault();
    onOpenDocument(href);
  };

  return (
    <Link
      download={isCustomDocument || undefined}
      href={href}
      onClick={handleClick}
      className={cn(LINK_CLASS, className)}
      {...NEW_TAB}
    >
      {t('privacy_policy')}
    </Link>
  );
}

export {PrivacyPolicyLink};
